import React from 'react';
import {DailyWeek} from '../types/ManagementOverviewReport.types';
import {
    formatDailyCell,
    formatWeekDayHeader,
} from '../utils/managementOverviewFormatters';

const WEEKDAY_HEADERS = [
    '2ª Feira',
    '3ª Feira',
    '4ª Feira',
    '5ª Feira',
    '6ª Feira',
    'Sábado',
    'Domingo',
];

interface DailyResultsTableProps {
    weeks: DailyWeek[];
}

const DailyResultsTable: React.FC<DailyResultsTableProps> = ({ weeks }) => {
    if (weeks.length === 0) {
        return null;
    }

    return (
        <section className="management-overview-daily-table avoid-break">
            <table>
                <thead>
                    <tr>
                        <th scope="col" />
                        {WEEKDAY_HEADERS.map((label) => (
                            <th scope="col" key={label}>{label}</th>
                        ))}
                    </tr>
                </thead>
                {weeks.map((week) => (
                    <tbody
                        key={week.weekName}
                        className="management-overview-daily-table__week"
                    >
                        <tr className="management-overview-daily-table__week-header">
                            <th scope="row">{week.weekName}</th>
                            {week.days.map((day, dayIndex) => (
                                <td key={`${week.weekName}-date-${day.date}-${dayIndex}`}>
                                    {formatWeekDayHeader(day.date, day.withinReferenceMonth)}
                                </td>
                            ))}
                        </tr>
                        {week.rows.map((row) => (
                            <tr key={`${week.weekName}-${row.label}`}>
                                <th scope="row">{row.label}</th>
                                {row.values.map((value, index) => (
                                    <td key={`${week.weekName}-${row.label}-${week.days[index]?.date ?? 'date'}-${index}`}>
                                        {formatDailyCell(value)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                ))}
            </table>
        </section>
    );
};

export default DailyResultsTable;
